import { Button, Flex, FormControl, Select } from '@chakra-ui/react'
import { Search } from '../../icons'
import { FormLabel } from '../FormLabel'
import { Datepicker } from '../Datepicker'
import { useForm } from 'react-hook-form'
import { useProductionGraphFilter } from './ProductionGraph'
import { CompaniesSelect } from '../../containers/CompaniesSelect'
import { useGetOrganizationUnits, useGetUsers } from '../../hooks/useUser'
import moment from 'moment'

export const Filters = () => {

  const { filter, updateFilter, loading } = useProductionGraphFilter()

  const methods = useForm({
    defaultValues: filter
  })
  const {
    register,
    watch,
    getValues,
    setValue,
    handleSubmit
  } = methods

  const submit = handleSubmit((formvalues) => {
    updateFilter(formvalues)
  })

  const { data: dataOrganizationUnits, isFetched: isFetchedOrganizationUnits } = useGetOrganizationUnits()
  const organizationUnits = dataOrganizationUnits?.data ?? []

  const { data: dataUsers, isFetched: isFetchedUsers } = useGetUsers()
  const users = dataUsers?.data ?? []

  const from = watch('from')

  return (
    <Flex sx={{ columnGap: 8, rowGap: 4, flexWrap: 'wrap', alignItems: 'end' }}>
      {/* Date start */}
      <FormControl>
        <FormLabel htmlFor="from">Datum od</FormLabel>

        <Datepicker
          date={from}
          onDateChange={(date) => {
            setValue('from', (date ?? filter.from).customSetHours(12))
          }}
          options={{
            maxDate: new Date().customSetHours(16),
          }}
        />
      </FormControl>

      {/* Date end */}
      <FormControl>
        <FormLabel htmlFor="to">Datum do</FormLabel>

        <Datepicker
          date={watch('to')}
          onDateChange={(date) => {
            setValue('to', (date ?? new Date()).customSetHours(12))
          }}
          options={{
            minDate: from ? new Date(from) : undefined,
            maxDate: new Date().customSetHours(16),
          }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Pojišťovna</FormLabel>

        <CompaniesSelect {...register('insurerId')} />
      </FormControl>

      {/* <FormControl>
        <FormLabel>Druh pojisného</FormLabel>

        <Select {...register('insuranceType')} defaultValue="">
          <option value="">Všechny druhy</option>
          <option value="pov">POV</option>
          <option value="hav">HAV</option>
        </Select>
      </FormControl> */}
      {organizationUnits.length > 0 &&
        <FormControl>
          <FormLabel>Organizace</FormLabel>

          <Select {...register('organizationUnitId')}>
            <option value=''>
              Všechny organizace
            </option>
            {organizationUnits.map((company) => {
              return (
                <option key={company.id} value={company.id.toString()}>
                  {company.name}
                </option>
              )
            })}
          </Select>
        </FormControl>
      }

      <FormControl>
        <FormLabel>Uživatel</FormLabel>

        <Select {...register('userId')} defaultValue="">
          <option value="">Všichni uživatelé</option>
          {users.map((user) => {
            return (
              <option key={user.userId} value={user.userId}>
                {user.surname} {user.name} ({organizationUnits.find(x => x.id.toString() === user.ouId?.toString())?.name})
              </option>
            )
          })}
        </Select>
      </FormControl>

      <Button
        variant="solid"
        colorScheme="primary"
        leftIcon={<Search />}
        onClick={submit}
      >
        Vyhledat
      </Button>
    </Flex>
  )
}
